import { PROVINCES } from './Common';


export default [
    PROVINCES.ALBERTA,
    PROVINCES.ONTARIO,
    PROVINCES.QUEBEC,
];